import { createNativeStackNavigator } from '@react-navigation/native-stack'
import { AccountPage } from 'components/pages/Account'
import { Chat } from 'components/pages/Chat'
import { CoachesPage } from 'components/pages/Coaches'
import { EditProfilePage } from 'components/pages/EditProfile'
import { FollowersFriendsPage } from 'components/pages/FollowersFriends'
import { MemberProfilePage } from 'components/pages/MemberProfile'
import { MembershipsPage } from 'components/pages/Memberships'
import { NotificationSettingsPage } from 'components/pages/NotificationSettings'
import { ProfilePage } from 'components/pages/Profile'
import { ShareProfilePage } from 'components/pages/ShareProfile'
import { UpspaceSettingsPage } from 'components/pages/UpspaceSettings'
import { WorkoutsPage } from 'components/pages/Workouts'
import React from 'react'

import * as constants from 'utils/constants'
import { links } from 'utils/constants'

export type ProfileStackParamList = {
  [constants.links.PROFILE_PAGE]: undefined
  [constants.links.FOLLOWERS_FRIENDS_PAGE]: undefined
  [constants.links.EDIT_PROFILE_PAGE]: undefined
  [constants.links.SHARE_PROFILE_PAGE]: undefined
  [constants.links.ACCOUNT_PAGE]: undefined
  [constants.links.UPSPACE_SETTINGS_PAGE]: undefined
  [constants.links.GROUP_STACK]: undefined
  [constants.links.CHAT_PAGE]: undefined
  [constants.links.MEMBERSHIPS_PAGE]: undefined
  [constants.links.NOTIFICATION_SETTINGS_PAGE]: undefined
  [constants.links.WORKOUTS_PAGE]: undefined
  [constants.links.MEMBER_PROFILE_PAGE]: undefined
  [constants.links.TRAINERS_PAGE]: undefined
}

const Stack = createNativeStackNavigator<ProfileStackParamList>()

export const ProfileStack = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
        gestureEnabled: true,
        title: 'Profile',
      }}
    >
      <Stack.Screen name={constants.links.PROFILE_PAGE} component={ProfilePage} />

      <Stack.Screen
        name={constants.links.FOLLOWERS_FRIENDS_PAGE}
        component={FollowersFriendsPage}
      />

      <Stack.Screen name={constants.links.EDIT_PROFILE_PAGE} component={EditProfilePage} />

      <Stack.Screen name={constants.links.MEMBERSHIPS_PAGE} component={MembershipsPage} />

      <Stack.Screen name={constants.links.SHARE_PROFILE_PAGE} component={ShareProfilePage} />

      <Stack.Screen name={constants.links.ACCOUNT_PAGE} component={AccountPage} />

      <Stack.Screen name={constants.links.UPSPACE_SETTINGS_PAGE} component={UpspaceSettingsPage} />

      <Stack.Screen
        component={WorkoutsPage}
        name={links.WORKOUTS_PAGE}
        options={{
          title: 'Workouts',
          headerShown: false,
        }}
      />

      <Stack.Screen
        name={constants.links.NOTIFICATION_SETTINGS_PAGE}
        component={NotificationSettingsPage}
      />

      <Stack.Screen
        name={constants.links.CHAT_PAGE}
        component={Chat}
        options={{
          title: 'Conversations',
          headerShown: false,
        }}
      />

      <Stack.Screen
        name={links.MEMBER_PROFILE_PAGE}
        component={MemberProfilePage}
        options={{
          title: 'Profile',
          headerShown: false,
        }}
      />

      <Stack.Screen
        component={CoachesPage}
        name={links.TRAINERS_PAGE}
        options={{
          title: 'Coaches',
          headerShown: false,
        }}
      />
    </Stack.Navigator>
  )
}
